module.exports = __webpack_public_path__ + "static/media/epiglow-5.50c82bfb.jpg";